import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor for logging
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// API functions
export const api = {
  // Launches
  getLaunches: async (limit = 20) => {
    const response = await apiClient.get("/launches", { params: { limit } });
    return response.data;
  },

  getLaunchDetail: async (id) => {
    const response = await apiClient.get(`/launches/${id}`);
    return response.data;
  },

  // News
  getNews: async (limit = 10) => {
    const response = await apiClient.get("/news", { params: { limit } });
    return response.data;
  },

  // Weather
  getWeather: async (zipCode = "32920") => {
    const response = await apiClient.get("/weather", { params: { zip_code: zipCode } });
    return response.data;
  },

  // Moon
  getMoon: async (zipCode = "32920") => {
    const response = await apiClient.get("/moon", { params: { zip_code: zipCode } });
    return response.data;
  },

  // ISS
  getISS: async () => {
    const response = await apiClient.get("/iss");
    return response.data;
  },

  // Sky Events
  getSkyEvents: async () => {
    const response = await apiClient.get("/sky-events");
    return response.data;
  },

  // Status (health check)
  getStatus: async () => {
    const response = await apiClient.get("/");
    return response.data;
  },
};

export default api;
